import React from 'react';
import { customersAPI } from '../../api/client';
import { useTranslation } from '../../context/TranslationContext';
import MasterDataManager from '../Common/MasterDataManager';

const Customers = () => {
  const { t } = useTranslation();

  const columns = [
    {
      header: t('customers.code', 'Customer Code'),
      field: 'customer_code',
      className: 'code-column'
    },
    {
      header: t('customers.name', 'Customer Name'),
      field: 'customer_name'
    },
    {
      header: t('created_at', 'Created'),
      field: 'created_at',
      render: (row) => new Date(row.created_at).toLocaleDateString(),
      sortable: false
    }
  ];

  const formFields = [
    {
      name: 'customerCode',
      label: 'customers.code',
      type: 'text',
      required: true,
      maxLength: 20
    },
    {
      name: 'customerName',
      label: 'customers.name',
      type: 'text',
      required: true,
      maxLength: 50
    },
    {
      name: 'notes',
      label: 'notes',
      type: 'textarea',
      rows: 3
    }
  ];

  return (
    <MasterDataManager
      title="customers.title"
      subtitle="customers.subtitle"
      createButtonLabel="customers.create"
      api={customersAPI}
      columns={columns}
      formFields={formFields}
      idField="customer_id"
      displayField="customer_code"
    />
  );
};

export default Customers;